import { render, staticRenderFns } from "./ModalImport.vue?vue&type=template&id=2a213e5d&"
import script from "./ModalImport.vue?vue&type=script&lang=js&"
export * from "./ModalImport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports